const FETCH_BV_QUESTION_ANSWER_REQUEST = 'FETCH_BV_QUESTION_ANSWER_REQUEST'
const FETCH_BV_QUESTION_ANSWER_SUCCESS = 'FETCH_BV_QUESTION_ANSWER_SUCCESS'
const FETCH_BV_QUESTION_ANSWER_FAILURE = 'FETCH_BV_QUESTION_ANSWER_FAILURE'

export { FETCH_BV_QUESTION_ANSWER_REQUEST, FETCH_BV_QUESTION_ANSWER_SUCCESS, FETCH_BV_QUESTION_ANSWER_FAILURE }
